import { render, staticRenderFns } from "./ViewForceChangePassword.vue?vue&type=template&id=e4dd7bf2&scoped=true&"
import script from "./ViewForceChangePassword.vue?vue&type=script&lang=js&"
export * from "./ViewForceChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dd7bf2",
  null
  
)

export default component.exports